export const useCustomFieldStore = defineStore('customField', () => {
  const customFields = ref<any>()
  function setData(data: any) {
    customFields.value = {
      ...(customFields.value ?? {}),
      ...data
    }
  }

  function getData(property?: string) {
    return property ? customFields?.value?.[property] : customFields?.value
  }

  return {
    setData,
    getData
  }
})
